/* eslint-disable */
import React from 'react';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import HeaderNano from '../../components/shared/SeoHeader';
import MainFeaturedPost from './MainFeaturedPost';
import Main from './Main';
import Sidebar from './Sidebar';
import post1 from './learningEngine.md';
import Spacer from '../../components/Agent/Spacer';
import FooterLight from '../../components/shared/SeoFooter';

import {
  faLinkedin,
  faTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { logger } from '../../utils/logger';

const sxStyles = {
  mainGrid: {
    marginTop: '24px',
  },
};

const mainFeaturedPost = {
  title: 'The Node That Keeps What It Learns',
  description:
    'The learning engine inside HARTOS writes what it learns into its weights, on your machine, and still knows it tomorrow. Measured against fine-tuning and replay, with the numbers.',
  image: '/HevolveBanner.webp',
  imgText: 'The node that keeps what it learns',
  linkText: 'Continue reading…',
};

const sidebar = {
  title: 'About',
  description:
    'Hevolve builds Nunba, a local-first multimodal AI agent that runs on your machine. Voice + vision + chat + channels you already use. Free, no subscription, open source.',
  archives: [
    { title: 'July 2026', url: '#' },
  ],
  social: [
    {
      name: 'Youtube',
      icon: faYoutube,
      link: 'https://www.youtube.com/channel/UClzFvo8SECdyd0dVQhJ2Cbg',
    },
    {
      name: 'Linkedin',
      icon: faLinkedin,
      link: 'https://www.linkedin.com/company/hertz-ai/',
    },
    {
      name: 'Twitter',
      icon: faTwitter,
      link: 'https://twitter.com/hertzai',
    },
  ],
};

export default function LearningEngineBlog() {
  const [posts, setPosts] = React.useState([]);

  React.useEffect(() => {
    logger.log('Learning-engine blog loaded');
    fetch(post1)
      .then((res) => res.text())
      .then((postContent) => setPosts([postContent]))
      .catch((err) => console.error(err));
  }, []);

  return (
    <React.Fragment>
      <HeaderNano />
      <Container maxWidth="lg">
        <main>
          <MainFeaturedPost post={mainFeaturedPost} />
          <Grid container spacing={5} sx={sxStyles.mainGrid}>
            <Main
              title="The Node That Keeps What It Learns"
              posts={posts}
              discoverMore="block"
            />
            <Sidebar
              title={sidebar.title}
              description={sidebar.description}
              archives={sidebar.archives}
              social={sidebar.social}
            />
          </Grid>
        </main>
      </Container>
      <Spacer h={120} />
      <FooterLight />
    </React.Fragment>
  );
}
